export enum LoginReducerActionType {
  SET_2FA = 'SET_2FA',
  SET_METHOD_2FA = 'SET_METHOD_2FA',
  SET_EMAIL = 'SET_EMAIL',
  SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN'
}
